export const NEW_COHORT = "2023-2024";
export const LEGACY_COHORT = "2020-2023";
